import React from 'react';

import OurBars from '../OurBars/OurBars';
import { HeaderInner } from '../Header/Header'
import { ReactComponent as LinzaSvg } from '../../../assets/icons/footerLinza.svg';

import localStyle from './styles.module.scss'


const Footer = () => {
  return (
    <>
    <OurBars/>
    <div className={localStyle['footer']}>
      <div className={localStyle['footerInner']}>
        <HeaderInner type='footer'/>
      </div>
      <div className={localStyle['secondRow']}>
        {/* <div className={localStyle['footer-logo']}><LogoSvg /></div> */}
        <div className={localStyle['legalInfo']}>
          <div className={localStyle['years']}>bardoski © ALL RIGHTS RESERVED. 1998-{new Date().getFullYear()}</div>
          <div className={localStyle['requisites']}>
            <div>ООО «ГАСТРОЛИГА»</div>
            <div>ИНН: 6685211900</div>
            <div>КПП: 783801001</div>
            <div>ОГРН: 1236600040720</div>
          </div>
        </div>
        <div className={localStyle['linza-svg']}>
          <LinzaSvg />
        </div>
      </div>
    </div>
    </>
  )
}

export default Footer;